// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://fcropqntzmdjmutvikny.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZjcm9wcW50em1kam11dHZpa255Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTgxOTIxMDIsImV4cCI6MjA3Mzc2ODEwMn0.SdWGbykOguVKEEMrhw93F0nEGo9AMY2r2fEKr34pUno";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});